import Api from "../config/api";

export const findAllMotivoCancelamentoLimitado = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($search: String, $pageableDTO: PageableDTOInput) {
      findAllMotivoCancelamentoLimitado(search: $search, pageableDTO: $pageableDTO) {
        last
        content {
          ativo
          descricao
          id
        }
      }
    }
  `,
    variables: variables,
  });

  if (response?.data?.errors) {
    throw Error(response.data.errors[0].message);
  }

  return response.data.data.findAllMotivoCancelamentoLimitado;
};

export const findMotivoCancelamentoLimitadoById = async (variables) => {
  const response = await Api.post("", {
    query: `
      query ($findMotivoCancelamentoLimitadoById: UUID) {
        findMotivoCancelamentoLimitadoById(id: $findMotivoCancelamentoLimitadoById) {
          ativo
          descricao
          id
        }
      }
  `,
    variables: variables,
  });

  if (response?.data?.errors) {
    throw Error(response.data.errors[0].message);
  }

  return response.data.data.findMotivoCancelamentoLimitadoById;
};

export const saveMotivoCancelamento = async (motivoCancelamentoLimitado) => {
  const nomeMutation = motivoCancelamentoLimitado?.id
    ? "updateMotivoCancelamentoLimitado"
    : "createMotivoCancelamentoLimitado";

  const response = await Api.post("", {
    query: `
      mutation ($motivoCancelamentoLimitado: MotivoCancelamentoLimitadoInput) {
      ${nomeMutation}(motivoCancelamentoLimitado: $motivoCancelamentoLimitado) {
        id
      }
    }
  `,
    variables: {motivoCancelamentoLimitado},
  });

  if (response?.data?.errors) {
    throw Error(response.data.errors[0].message);
  }

  return response.data.data.findMotivoCancelamentoLimitadoById;
};
